import { useSelector } from "react-redux";
import axiosInstance from "../config/AxiosConfig";
import { BaseResponse } from "../domain/payload/response/BaseResponseDto";
import { TaskDetailResp } from "../domain/payload/response/task/TaskDetailResp";
import { TaskFormResp } from "../domain/payload/response/task/TaskFormResp";
import { TaskFormSubmitReq, MoreAccessFormSubmitReq } from "../domain/payload/request/task/TaskFormSubmitReq";
import { TaskUploadDocumentResp } from "../domain/payload/response/task/TaskUploadDocumentResp";

const TaskService = () => {
  const { token } = useSelector((state: any) => state.auth);

  const taskWebFormDetail = async (sessionId: string): Promise<BaseResponse<TaskDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/task/web-form/detail`, {
        headers: {
          ...axiosInstance.defaults.headers.head,
          Authorization: `Bearer ${token}`
        },
        params: {
          sessionId: sessionId,
        },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const taskForm = async (sessionId: string): Promise<BaseResponse<TaskFormResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/task/web-form/question`, {
        headers: {
          ...axiosInstance.defaults.headers.head,
          Authorization: `Bearer ${token}`
        },
        params: {
          sessionId: sessionId,
          lat: 0,    
          lng: 0,  
        },
      });

      return response.data;

    } catch (error: any) {
      throw error.response?.data?.message || 'Gagal memuat form';
    }
  };

  const taskWebFormTry = async (demoCode: string): Promise<BaseResponse<TaskFormResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/task/web-form/question/try`, {
        headers: {
          ...axiosInstance.defaults.headers.head,
          Authorization: `Bearer ${token}`
        },
        params: {
          demoCode: demoCode,
        },
      });

      return response.data;

    } catch (error: any) {
      throw error.response?.data?.message || 'Gagal memuat form demo';
    }
  };

  const taskSubmitData = async (request: TaskFormSubmitReq): Promise<BaseResponse<TaskFormResp>> => {
    try {
      console.log('Submit Request with coordinates:', {
        latitude: request.latitude,
        longitude: request.longitude
      });
      
      console.log('Full request:', JSON.stringify(request, null, 2));
      
      const response = await axiosInstance.post(`/v1/legacy/task/web-form/submit`, request, {
        headers: {
          ...axiosInstance.defaults.headers.head,
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      console.log('Submit Response:', response.data);
      return response.data;
    } catch (error: any) {
      console.log('Submit Error:', error.response?.data);
      throw error.response?.data?.message || 'Gagal mengirim form';
    }
  };

  const taskUploadDocument = async (
    sessionId: string,
    fieldId: string,
    file: File
  ): Promise<BaseResponse<TaskUploadDocumentResp>> => {
    try {
      console.log("start taskUploadDocument")
      console.log(sessionId)
      console.log(fieldId)

      const formData = new FormData();
      formData.append("sessionId", sessionId);
      formData.append("fieldId", fieldId);
      formData.append("file", file);

      const response = await axiosInstance.post(`/v1/legacy/task/web-form/upload-document`, formData, {
        headers: {
          ...axiosInstance.defaults.headers.head,
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log(response.data)
      return response.data;
    } catch (error: any) {
      console.log(error.response)
      throw error.response.data.message;
    }
  };


  const taskFormByMAccess = async (
    tId: string,
    lat: number,
    lng: number
  ): Promise<BaseResponse<TaskFormResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/task/web-form-access/form/question`, {
        params: { tId, lat, lng },
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || 'Gagal memuat form';
    }
  };

  const taskSubmitDataByMAccess = async (
    tId: string,
    request: MoreAccessFormSubmitReq
  ): Promise<BaseResponse<{ resultId: string }>> => {
    try {
      const response = await axiosInstance.post(
        `/v1/legacy/task/web-form-access/form/submit`,
        request,
        { params: { tId } }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || 'Gagal mengirim form';
    }
  };

  const taskUploadDocumentByMAccess = async (
    tId: string,
    taskId: string,
    fieldId: string,
    file: File
  ): Promise<BaseResponse<TaskUploadDocumentResp>> => {
    try {
      const formData = new FormData();
      formData.append("taskId", taskId);
      formData.append("fieldId", fieldId);
      formData.append("file", file);

      const response = await axiosInstance.post(
        `/v1/legacy/task/web-form-access/form/uploadDocument`,
        formData,
        { params: { tId }, headers: { 'Content-Type': 'multipart/form-data' } }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || 'Gagal upload foto';
    }
  };

  return {
    taskWebFormDetail,
    taskForm,
    taskWebFormTry,     
    taskSubmitData,
    taskUploadDocument,
    taskFormByMAccess,
    taskSubmitDataByMAccess,
    taskUploadDocumentByMAccess,
  };
};

export default TaskService;